import registrationConfig from '@cms/core/config/registration/index';
import mastheadConfig from '@cms/core/config/registration/mastheads';

export { default as getRegistrationLockedStatus } from './getRegistrationLockedStatus';


// get data for current env
export const getEnvConfig = (env) => registrationConfig.environment[env] || {};

// get enabled status for environment
export const getEnabledStatus = (environmentConfig) => (
  registrationConfig.enabled &&
  environmentConfig.enabled
);

// // Get
export const getEnabledStatusForEnv = (env) => {
  const config = getEnvConfig(env);
  const enabled = getEnabledStatus(config);
  return enabled;
};

// Get enabled status for current site in current environment.
export const getEnabledStatusForSite = (registrationConfig, environmentConfig, site) => (
  getEnabledStatus(registrationConfig, environmentConfig) &&
  environmentConfig.sites.includes(site)
);

// Get Registration config for the current site.
export const getMastheadConfig = (code) => {
  const masthead = mastheadConfig.get(code);
  if (!masthead) console.error(`Cant get masthead config for ${ code }`, mastheadConfig);
  return masthead;
};

// Get the base url for current site. Defaults to caasId.
// Site config can also specify basename string or custom _getBaseUrlForSite function
export const getBaseUrlForSite = (config, env) => {
  if (typeof config._getBaseUrlForSite === 'function') {
    return config._getBaseUrlForSite(config, env);
  }

  const baseDomain = (config.basename || config.caasId);
  const domain = `https://www.${ baseDomain }${ env.domainSuffix }.com.au`;

  return domain;
};


// get registration config for current environment and site.
export function getRegistrationConfig({ env, site }) {
  const envConfig = getEnvConfig(env);
  const enabled = getEnabledStatusForSite(registrationConfig, envConfig, site);

  const config = site && getMastheadConfig(site);
  const baseUrl = config && getBaseUrlForSite(config, envConfig);

  return {
    enabled,
    site: {
      ...config,
      baseUrl
    },
    env: {
      ...envConfig,
      env
    },
  };
}
